document.addEventListener('DOMContentLoaded', function() {
  // Das Hidden-Input mit name="id" enthält die Variant-ID der aktuell ausgewählten Variante
  const hiddenVariantInput = document.querySelector('form input[name="id"]');
  if (!hiddenVariantInput) return;

  const defaultVariantId = hiddenVariantInput.value;

  // Alle Grundpreis-Container ausblenden
  document.querySelectorAll('.variant-grundpreis').forEach(function(el) {
    el.style.display = 'none';
  });

  // Nur den für defaultVariantId passenden anzeigen
  const matchingBlock = document.querySelector(`.variant-grundpreis[data-variant-id="${defaultVariantId}"]`);
  if (matchingBlock) {
    matchingBlock.style.display = 'block';
  }
});

